import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "64",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m.843 13.098 6.784 12.57 1.187 2.2 2.2-1.187 8.933-4.821 5.597 10.37 4.4-2.375-6.784-12.57-1.187-2.2-2.2 1.187-8.933 4.821-5.596-10.37zm41.269-9.81 6.783 12.57 1.188 2.2 2.2-1.188 8.933-4.82 5.596 10.369 4.4-2.375-6.783-12.57-1.188-2.2-2.2 1.188-8.933 4.82L46.512.914zm-5.608 54.014-6.784-12.57 4.4-2.374 5.597 10.37 8.933-4.822 2.2-1.187 1.187 2.2 6.784 12.57-4.4 2.374-5.597-10.37-8.933 4.822-2.2 1.187z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }